import React, { type FC } from 'react';
import { TemplateItem } from './TemplateItem';
import css from './TemplatesGrid.scss';
import { DataHooks } from '../../../constants/dataHooks';
import type { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { Layout } from '@wix/design-system';
import classNames from 'classnames';

export type OnTemplateClickFunc = (template: AppTemplate) => void;

type Props = {
  templates: AppTemplate[];
  onTemplateClick: OnTemplateClickFunc;
  showMoreThanTwoInRow?: boolean;
};

export const TemplatesGrid: FC<Props> = ({
  templates,
  onTemplateClick,
  showMoreThanTwoInRow = true,
}) => {
  const templatesCount = templates.length;
  const layoutGridClass =
    showMoreThanTwoInRow && templatesCount > 2
      ? css.layoutThreeOrMoreTemplates
      : css.layoutTwoOrLessTemplates;

  return (
    <Layout
      gap="SP4"
      className={classNames(css.layout, layoutGridClass)}
      dataHook={DataHooks.TemplatesGridWrapper}
    >
      {templates.map((template, index) => (
        <TemplateItem
          index={index}
          key={template.id}
          template={template}
          onTemplateClick={onTemplateClick}
        />
      ))}
    </Layout>
  );
};
